import { handleActions } from 'redux-actions'
import { deleteUniqueAiObject } from '@tabeeb/modules/artificialIntelligence/actions'
import { setAiReportNeedToRefresh, getAiObjectAnalysis } from '../actions'

const defaultState = false

export default handleActions(
  {
    [setAiReportNeedToRefresh](state, action) {
      return action.payload
    },
    [getAiObjectAnalysis.request](state, action) {
      return defaultState
    },
    [deleteUniqueAiObject.success](state, action) {
      return true
    },
  },
  defaultState
)
